import { ColumnDef } from "@tanstack/react-table";
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/Datatable";
import NACell from "../Reusable/Datatable/NACell";
import Filter from "./Filter";
import { useSearchParams } from "react-router-dom";
import { useForm, useWatch } from "react-hook-form";
import { useDownload } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import moment from "moment";
import Button from "../Reusable/Button";

const StockValuationNormal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const { download } = useDownload();
  const {
    control,
    register,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      account: searchParams.get("account") || "",
      user: searchParams.get("user") || "",
      created__range: `${startOfMonth},${endOfMonth}`,
      created: searchParams.get("created") || "",
    },
  });
  const formValues = useWatch({ control });
  const columns: ColumnDef<any, any>[] = [
    {
      accessorKey: "name",
      header: "Product Name",
      cell: NACell,
    },
    {
      accessorKey: "unit.name",
      header: "Unit",
      cell: NACell,
    },
    {
      accessorKey: "closing_quantity",
      header: "Quantity",
      cell: ({ getValue }: any) => <p>{getValue() ?? 0}</p>,
    },
    {
      accessorKey: "last_purchased_price",
      header: "Rate",
      cell: ({ getValue }: any) => (
        <p>
          {Number(getValue()).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) ?? 0}
        </p>
      ),
    },
    {
      accessorKey: "total",
      header: "Value",
      cell: ({ getValue }: any) => (
        <p>
          {Number(getValue()).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) ?? 0}
        </p>
      ),
    },
  ];
  const handleDownloadExcel = async () => {
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(formValues)
          .filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
          .map(([key, value]) => [key, String(value)])
      );

      const queryString = new URLSearchParams(cleanedParams).toString();

      await download(
        `${APIS.PRODUCT}stock-valuation-excel-download/?${queryString}`,
        `stock-valuation-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <>
      <Filter
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <div className={tw`flex justify-end mb-2`}>
        <div className={tw`w-24`}>
          <Button label="Download" onClick={() => handleDownloadExcel()} />
        </div>
      </div>
      <DataTable
        columns={columns}
        queryKey={"stock-valuation-normal"}
        url={`${APIS.PRODUCT}valuation/`}
        params={formValues}
        customSearch={true}
        tableName="stock-valuation-normal"
      />
    </>
  );
};
export default StockValuationNormal;

